import { useLang } from '../../i18n';
import { SmartImg } from '../Image';
import { FadeUp, MaskedLines } from '../motion';

export default function WhyWired() {
  const { t } = useLang();
  return (
    <section
      data-testid="why-wired-section"
      className="border-t border-black/10 bg-white px-4 py-20 sm:px-8 sm:py-28 lg:px-16"
    >
      <FadeUp>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">
          02 — {t('why.label')}
        </p>
      </FadeUp>

      <MaskedLines
        className="mt-10 font-mono text-3xl uppercase leading-[1.2] tracking-[0.14em] sm:text-6xl lg:text-7xl"
        stagger={0.16}
        lines={['No battery.', 'No pairing.', 'No case.']}
      />

      <FadeUp delay={0.25}>
        <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-700 sm:text-xs">
          {t('why.sub1')}
        </p>
      </FadeUp>
      <FadeUp delay={0.35}>
        <p className="mt-4 max-w-md font-mono text-[10px] uppercase leading-loose tracking-[0.2em] text-neutral-500">
          {t('why.sub2')}
        </p>
      </FadeUp>

      <FadeUp delay={0.2} className="mt-14">
        <SmartImg
          src="/assets/why-wired-earphones.webp"
          alt="01 / CHROME — auricolari cablati in cromo"
          label="01 / Chrome"
          className="mx-auto aspect-[9/16] w-full max-w-md object-contain"
        />
      </FadeUp>
    </section>
  );
}
